export default __webpack_public_path__ + "static/media/chem.7d3576ec.svg";